export const elapsedCallSeconds = (timeAnswered, nowSeconds) => {
  const answeredAt = Number(timeAnswered || 0);
  const now = Number(nowSeconds || 0);
  return answeredAt > 0 && now >= answeredAt ? now - answeredAt : 0;
};

export const formatCallTime = (seconds) => {
  const safeSeconds = Math.max(0, Math.floor(Number(seconds || 0)));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const remainingSeconds = safeSeconds % 60;
  return [hours, minutes, remainingSeconds]
      .map((value) => String(value).padStart(2, "0"))
      .join(":");
};
